export default "__VITE_ASSET__ACj0V0yp__"